import { render, staticRenderFns } from "./breakpoint-settings.vue?vue&type=template&id=d104ec00&scoped=true"
import script from "./breakpoint-settings.vue?vue&type=script&lang=js"
export * from "./breakpoint-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d104ec00",
  null
  
)

export default component.exports